var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "更新盘库明细",
        "before-close": _vm.close,
        width: "600px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "p16" },
        [
          _c(
            "el-form",
            {
              ref: "checkFormRef",
              attrs: {
                rules: _vm.formRules,
                model: _vm.formData,
                "label-width": "100px",
                size: "medium",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  $event.preventDefault()
                },
              },
            },
            [
              _c("el-form-item", { attrs: { label: "明细ID" } }, [
                _vm._v(" 【 " + _vm._s(_vm.info.id) + " 】 "),
              ]),
              _c("el-form-item", { attrs: { label: "商品名称" } }, [
                _vm._v(" " + _vm._s(_vm.info.goodsName) + " "),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "实际库存", props: "actualQty" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, step: 1, precision: 0 },
                    model: {
                      value: _vm.formData.actualQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "actualQty", $$v)
                      },
                      expression: "formData.actualQty",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注信息", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.formData.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "remark", $$v)
                      },
                      expression: "formData.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("更新")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }